import { render, staticRenderFns } from "./RealtimeHistory.vue?vue&type=template&id=c58c8fc6&scoped=true&"
import script from "./RealtimeHistory.vue?vue&type=script&lang=js&"
export * from "./RealtimeHistory.vue?vue&type=script&lang=js&"
import style0 from "./RealtimeHistory.vue?vue&type=style&index=0&id=c58c8fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58c8fc6",
  null
  
)

export default component.exports